"use client";

import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';

const testimonials = [
  {
    quote: "Mit Umynd konnte ich mich optimal auf meine Interviews vorbereiten. Die KI-Unterstützung hat mir geholfen, selbstbewusster aufzutreten und letztendlich meinen Traumjob zu bekommen.",
    author: "Laura M.",
    position: "Software-Entwicklerin"
  },
  {
    quote: "Der Bewerbungsprozess wurde durch Umynd viel transparenter und effizienter. Ich wusste immer genau, in welcher Phase ich mich befinde und was als nächstes kommt.",
    author: "Markus K.",
    position: "Projektmanager"
  },
  {
    quote: "Die KI-gestützte Interviewvorbereitung hat mir enorm geholfen. Ich konnte meine Stärken besser präsentieren und habe eine Position erhalten, die perfekt zu mir passt.",
    author: "Sarah L.",
    position: "Marketing-Spezialistin"
  }
];

const fadeInUp = {
  hidden: { opacity: 0, y: 20 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { duration: 0.6 }
  }
};

export function CandidateTestimonials() {
  return (
    <section className="py-20 bg-thistle-50">
      <div className="container mx-auto px-4">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeInUp}
          className="text-center mb-12"
        >
          <h2 className="text-h2 mb-2">Das sagen unsere Kandidaten</h2>
          <div className="w-24 h-1 mx-auto rounded-full bg-thistle-dark" />
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={fadeInUp}
              custom={index}
              className={cn(
                "bg-white p-8 rounded-xl shadow-md",
                "flex flex-col justify-between",
                "min-h-[300px]"
              )}
            >
              <div>
                <svg 
                  className="w-10 h-10 text-thistle-dark/30 mb-4" 
                  fill="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path d="M14.017 21v-7.391C14.017 10.141 16.418 8 19.642 8c.154 0 .307.004.459.013v3.745c-.146-.012-.285-.025-.427-.025-1.214 0-2.197.986-2.197 2.201V21h-3.46zM6.76 20.987v-7.39c0-3.468 2.402-5.61 5.625-5.61.154 0 .307.004.459.013v3.746c-.146-.012-.285-.025-.427-.025-1.214 0-2.197.986-2.197 2.201v7.07H6.76z" />
                </svg>
                <p className="text-foreground/80 italic mb-6">{testimonial.quote}</p>
              </div>
              <div>
                <p className="font-gilroy font-bold">{testimonial.author}</p>
                <p className="text-foreground/60 text-sm">{testimonial.position}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}